export const RSD = new Intl.NumberFormat("sr-RS", {
  style: "currency",
  currency: "RSD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const EUR = new Intl.NumberFormat("sr-RS", {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export const USD = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const getEurToUsdRate = async (): Promise<number> => {
  const response = await fetch("https://open.er-api.com/v6/latest/EUR");

  if (!response.ok) {
    throw new Error("Failed to fetch exchange rate");
  }

  const exchangeData = await response.json();

  if (exchangeData.result !== "success") {
    throw new Error("Exchange rate API returned an error");
  }

  const eurToUsdRate = exchangeData.rates?.USD;

  if (!eurToUsdRate) {
    throw new Error("Could not get EUR to USD conversion rate");
  }

  return eurToUsdRate;
};
